// @flow
import React from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import {
  getStatus as getResourceStatus,
} from 'redux-resource';

import type {
  Dispatch,
} from 'chronos-types';

import * as actions from 'chronos-actions';
import * as selectors from 'chronos-selectors';

import {
  Footer,
} from 'chronos-components';

const mapState = state => ({
  groupBy: selectors.getUiState('groupBy')(state),
  worklogs: selectors.getWorklogsFiltered(state),
  timeWorked: selectors.getTimeWorked(state),
  calendarDate: selectors.getUiState('calendarDate')(state),
  calendarSelection: selectors.getUiState('calendarSelection')(state),
  sidebarSelection: selectors.getUiState('sidebarSelection')(state),
  isInfoModalVisible: selectors.getUiState('isInfoModalVisible')(state),
  isServerSettingsModalVisible: selectors.getUiState('isServerSettingsModalVisible')(state),
  jiraType: selectors.getUiState('jiraType')(state),
  profile: selectors.getProfile(state),
  status: getResourceStatus(state, 'issues.requests.loadingFilterOptions.status', true),
});

const FooterWrapper = () => {
  const {
    groupBy,
    worklogs,
    timeWorked,
    calendarDate,
    calendarSelection,
    sidebarSelection,
    isInfoModalVisible,
    isServerSettingsModalVisible,
    jiraType,
    profile,
    status,
  } = useSelector(mapState);

  const dispatch: Dispatch = useDispatch();
  return (
    <Footer
      groupBy={groupBy}
      timeWorked={timeWorked}
      calendarDate={calendarDate}
      worklogs={worklogs}
      fetching={status.pending}
      showGuide={() => {
        dispatch(actions.setUiState({
          showGuide: true,
        }));
      }}
      selectedDaysCount={calendarSelection.length}
      selectedRowsCount={sidebarSelection[groupBy].length}
      clearSelectedDays={() => dispatch(actions.clearCalendarSelection())}
      clearTimelineSelection={() => dispatch(actions.clearAllSidebarItems())}
      isInfoModalVisible={isInfoModalVisible}
      isServerSettingsModalVisible={isServerSettingsModalVisible}
      jiraType={jiraType}
      isSystemAdmin={profile?.userData?.permissions?.SYSTEM_ADMIN?.havePermission}
      setInfoModalVisibility={visible => dispatch(actions.setUiState({
        isInfoModalVisible: visible,
      }))}
      setServerSettingsModalVisibility={visible => dispatch(actions.setUiState({
        isServerSettingsModalVisible: visible,
      }))}
    />
  );
};

export default FooterWrapper;
